import {
  Button,
  Card,
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  Modal,
  Placeholder,
  Row,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import LogoCode from "./Logo.Code";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage, faUpload, faTrash } from "@fortawesome/free-solid-svg-icons";

const LogoView = () => {
  const {
    loading,
    salvando,
    hasLogo,
    logoUrl,
    previewModal,
    show,
    handleShow,
    handleClose,
    handleFileChange,
    handleSubmitIncluir,
    onSubmitIncluir,
    registerIncluir,
    errorsIncluir,
    handleRemover,
  } = LogoCode();

  return (
    <Container>
      <HeadPage headText="Logo">
        <Dropdown.Item onClick={handleShow}>
          {hasLogo ? "Alterar Logo..." : "Nova Logo..."}
        </Dropdown.Item>
        {hasLogo && (
          <Dropdown.Item onClick={handleRemover}>
            Remover Logo...
          </Dropdown.Item>
        )}
      </HeadPage>

      <Modal show={show} onHide={handleClose}>
        <Form noValidate onSubmit={handleSubmitIncluir(onSubmitIncluir)}>
          <Modal.Header closeButton>
            <Modal.Title>{hasLogo ? "Alterar Logo" : "Nova Logo"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Selecione a imagem (*.png, *.jpg, *.jpeg, *.webp)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/png, image/jpeg, image/jpg, image/webp"
                    isInvalid={!!errorsIncluir?.arquivo?.message}
                    {...registerIncluir("arquivo", {
                      onChange: handleFileChange,
                    })}
                  />
                  {errorsIncluir?.arquivo?.message?.toString() && (
                    <Form.Control.Feedback type="invalid">
                      {errorsIncluir?.arquivo?.message?.toString()}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
                {previewModal && (
                  <div className="text-center mt-3 p-3 bg-light rounded border">
                    <p className="text-muted small mb-2">Pré-visualização:</p>
                    <img
                      src={previewModal}
                      alt="Pré-visualização"
                      style={{
                        maxHeight: "150px",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                )}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="default" onClick={handleClose}>
              Fechar
            </Button>
            <Button variant="primary" type="submit" disabled={salvando}>
              {salvando ? "Enviando..." : "Enviar"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {!loading ? (
        <Row className="justify-content-center mt-4">
          <Col xs={12} sm={10} md={8} lg={6}>
            <Card className="shadow-sm">
              <Card.Header className="bg-transparent fw-semibold">
                Logo da Empresa
              </Card.Header>
              <Card.Body className="text-center p-4">
                {hasLogo && logoUrl ? (
                  <>
                    <div
                      className="mb-4 d-flex align-items-center justify-content-center p-3 border rounded bg-light"
                      style={{ minHeight: "220px" }}
                    >
                      <img
                        src={logoUrl}
                        alt="Logo da Empresa"
                        className="img-fluid"
                        style={{
                          maxHeight: "200px",
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <div className="d-flex justify-content-center gap-2">
                      <Button variant="outline-primary" onClick={handleShow}>
                        <FontAwesomeIcon icon={faUpload} className="me-2" />
                        Alterar Logo
                      </Button>
                      <Button variant="outline-danger" onClick={handleRemover}>
                        <FontAwesomeIcon icon={faTrash} className="me-2" />
                        Remover Logo
                      </Button>
                    </div>
                  </>
                ) : (
                  <div className="py-4 text-muted">
                    <FontAwesomeIcon
                      icon={faImage}
                      size="4x"
                      className="mb-3 text-secondary opacity-50"
                    />
                    <h5 className="text-secondary">Nenhuma logo vinculada</h5>
                    <p className="text-muted small mb-3">
                      Adicione o logotipo da sua empresa para utilizá-lo nos documentos e relatórios.
                    </p>
                    <Button variant="primary" onClick={handleShow}>
                      <FontAwesomeIcon icon={faUpload} className="me-2" />
                      Vincular Logo
                    </Button>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : (
        <Placeholder as={FloatingLabel} animation="glow">
          <Placeholder xs={12} style={{ height: "200px" }} />
        </Placeholder>
      )}
    </Container>
  );
};

export default LogoView;
